package com.ervasstudio.tracoemovimento.util

import com.varabyte.kobweb.compose.ui.graphics.Color

object Res {

    object Constants {
        const val FONT_FAMILY = "Roboto"
        const val SIDE_PANEL_WIDTH = 250
        const val PAGE_WIDTH = 1920
        const val COLLAPSED_PANEL_HEIGHT = 100
        const val HEADER_HEIGHT = 100
        const val HUMOR_API_URL = "https://api.humorapi.com/jokes/random?api-key=de26700644aa43abbbd73d8a05af5d49&max-length=180"


    }

    object MyColors {
        val AccentYellow = Color.rgb(0xF8CA3C)
        val PretoDesfalecido = Color.rgb(79,79,79)
        val Lilas = Color.rgb(119,102,168)
        val SurfaceContent = Color.rgb(229,229,229)
    }

    object Strings {
        const val ABOUT_US_PARAGRAPH_1 = "O Traço e Movimento é um projecto que nasce da necessidade de criar animação a partir de uma perspectiva africana com a nossa voz, o nosso ritmo e o nosso imaginário."
        const val ABOUT_US_PARAGRAPH_2 = "Somos um estúdio e também um espaço de aprendizagem. Um laboratório onde o desenho, a cultura visual africana e as ferramentas contemporâneas se encontram."
        const val ABOUT_US_PARAGRAPH_3 = "Nós entendemos que animar não é apenas produzir frames é dar significado ao movimento. O traço não é decoração, é linguagem. O movimento não é técnica, é espírito."
        const val ABOUT_US_PARAGRAPH_4 = "Trabalhamos com formação, desenvolvimento de projectos, pesquisa visual, consultoria criativa e produção de conteúdos audiovisuais."
        const val ABOUT_US_PARAGRAPH_5 = "Da publicidade à ficção, do desenho em papel ao digital o foco é sempre o mesmo, criar imagens com identidade."
        const val ABOUT_US_PARAGRAPH_6 = "Queremos formar novos animadores, fortalecer a nossa indústria e mostrar que a animação africana tem um lugar no mundo."


        const val ABOUT_US_PARAGRAPH_1_LINE_1 = "O Traço e Movimento é um projecto que nasce da necessidade"
        const val ABOUT_US_PARAGRAPH_1_LINE_2 = "de criar animação a partir de uma perspectiva africana com a"
        const val ABOUT_US_PARAGRAPH_1_LINE_3 = "nossa voz, o nosso ritmo e o nosso imaginário."

        const val ABOUT_US_PARAGRAPH_2_LINE_1 = "Somos um estúdio e também um espaço de aprendizagem."
        const val ABOUT_US_PARAGRAPH_2_LINE_2 = "Um laboratório onde o desenho, a cultura visual africana e as"
        const val ABOUT_US_PARAGRAPH_2_LINE_3 = "ferramentas contemporâneas se encontram."

        const val ABOUT_US_PARAGRAPH_3_LINE_1 = "Nós entendemos que animar não é apenas produzir frames é"
        const val ABOUT_US_PARAGRAPH_3_LINE_2 = "dar significado ao movimento. O traço não é decoração, é linguagem."
        const val ABOUT_US_PARAGRAPH_3_LINE_3 = "O movimento não é técnica, é espírito."

        const val ABOUT_US_PARAGRAPH_4_LINE_1 = "Trabalhamos com formação, desenvolvimento de projectos,"
        const val ABOUT_US_PARAGRAPH_4_LINE_2 = "pesquisa visual, consultoria criativa e produção de conteúdos"
        const val ABOUT_US_PARAGRAPH_4_LINE_3 = "audiovisuais."
        const val ABOUT_US_PARAGRAPH_4_LINE_4 = "Da publicidade à ficção, do desenho em papel ao digital o foco é"
        const val ABOUT_US_PARAGRAPH_4_LINE_5 = "sempre o mesmo, criar imagens com identidade."

        const val ABOUT_US_PARAGRAPH_5_LINE_1 = "Queremos formar novos animadores, fortalecer a nossa indústria"
        const val ABOUT_US_PARAGRAPH_5_LINE_2 = "e mostrar que a animação africana tem um lugar no"
        const val ABOUT_US_PARAGRAPH_5_LINE_3 = "cinema, no mercado criativo e na imaginação global."
    }

    object Image {
        const val logo = "/logo_tm.png"
        const val logos = "/logos.jpg"
        const val grid = "/grid.png"
        const val akin = "/akin.gif"
        const val bolasite = "/bolasite.gif"
        const val bolasitemobile = "/bolasitemobile.gif"
        const val usuario = "/user.png"
        const val user = "/user.svg"
        const val xish = "/xish.png"
        const val bg_projecto = "/bgprojecto.png"
        const val seta_glow = "/xish.png"
        const val linhas = "/linhas_white.svg"
        const val globo = "/globo.png"
        const val tira = "/tirarolante.png"
        const val halter = "/halter.png"
        const val estrelinha = "/estrelinha.png"
        const val bgpopup = "/bgpopup.png"
        const val fuguetao = "/fuguetao.png"
        const val ovni = "/ovni.png"
        const val evento = "/event.svg"
        const val bgstyle = "/bgstyle.png"
        const val butaobg = "/butaobg.png"
        const val fb = "/facebook.svg"
        const val fblilas = "/facebooklilas.svg"
        const val ig = "/instagram.svg"
        const val iglilas = "/instagramlilas.svg"
        const val ervaslogolilas = "/ervaslogolilas.svg"
        const val ervaslogo = "/ervaslogo.svg"

        const val tracoemovultra = "/tracoemovultra.png"
        const val bgpopupsmall = "/bgpopupsmall.png"
        const val glogo = "/glogo.svg"
        const val dropdown = "/dropdown.svg"
        const val pagamentos = "/pagamentos.svg"
        const val usermenu = "/usermenu.svg"
        const val help = "/help.svg"
        const val logout = "/logout.svg"


        const val damiao = "/damiao.jpg"
        const val darling = "/darling.jpg"
        const val lucien = "/lucien.jpg"
        const val marcos = "/marcos.jpg"
        const val narciso = "/narciso.jpg"
        const val santana = "/santana.jpg"
    }

    object Icon {
        const val bold = "/bold.svg"
    }

}